module.exports = __webpack_public_path__ + "img/krampus-kibble-can-560w.a0b30119.png";